import NoContentPlaceHolder from '@/widgets/components/no-content-placeholder';
import React from 'react';
import { Steps } from 'rsuite';
import { DATA_STATUS, EMPTY_LIST, LOADING_ACTIVITIES } from '@/constants';
import { LoadingPlaceholder } from '@/widgets/components/data-loading-placeholder';
import styled from 'styled-components';
import { FeedItem } from './feed-item';

const StyledSteps = styled(Steps)`
  width: 100%;

  .rs-steps-item-icon {
    display: flex !important;
    height: 21px !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100%;
  }
`;

const Wrapper = styled.div`
  width: 100%;
`;

const CURRENT_STEP = 1;

/**
 * This component renders each item in the ActivityFeed
 *
 * @param {List} props.activityData Immutable List that holds the activity data
 */
export function ActivityItems({ activityData }) {
  // null is initial state. We imply that there will be a fetch request.
  if (DATA_STATUS.inProgress === activityData || activityData === null) {
    return <LoadingPlaceholder loadingText={LOADING_ACTIVITIES} />;
  }

  if (activityData?.size === EMPTY_LIST) {
    return (
      <Wrapper>
        <NoContentPlaceHolder />
      </Wrapper>
    );
  }
  return (
    // TODO: Ask Bing about behavior of stepper
    <Wrapper>
      <StyledSteps current={CURRENT_STEP} vertical>
        {activityData.map(({ type, value }, index) => (
          <FeedItem key={value.id} type={type} value={value} index={index} />
        ))}
      </StyledSteps>
    </Wrapper>
  );
}
